import React from 'react';
import { LiaHeadsetSolid } from "react-icons/lia";   
import { IoShieldCheckmarkOutline } from "react-icons/io5"; 
import { CiDeliveryTruck } from "react-icons/ci";        
import { FaMoneyBill1Wave } from "react-icons/fa6";     

import '../styles/whyus.scss'; 

const FeatureIcon = ({ IconComponent, title, description }) => (
    <div className="features__item">
        <div className="features__icon">
            <IconComponent />
        </div>
        <div className="feature-text">
            <p className="features__title">{title}</p>
            <p className="features__description">{description}</p> 
        </div>
    </div>
);

const WhyUs = () => {
    return (
        <section className="hero-section-features">
            
            {/* --- Left Column: Images (Unchanged Visual Layout) --- */}
            <div className="hero-section__images">
                <div className="image-stack">
                    <div className="image-stack__large image-1"></div>
                    <div className="image-stack__center image-2"></div>
                </div>
            </div>

            <div className="hero-section__content">
                <h1 className="content__heading">Why Trust Artiza With Your Vision?</h1>
                <p className="content__description">
                    Our process guarantees clarity, connects you with master artisans, and assures the final quality of your bespoke furniture.
                </p>

                <div className="features-grid">
                    <FeatureIcon 
                        IconComponent={IoShieldCheckmarkOutline} 
                        title="Vetted Artisan Network" 
                        description="Access master craftsmen rigorously screened for skill and commitment to excellence."
                    />
                    <FeatureIcon 
                        IconComponent={LiaHeadsetSolid} 
                        title="Dedicated Project Support" 
                        description="We handle communication, design updates, and logistics from start to finish."
                    />
                    <FeatureIcon 
                        IconComponent={FaMoneyBill1Wave} 
                        title="Guaranteed Specification" 
                        description="Your payment ensures the piece matches your technical drawing and quality expectations."
                    />
                    <FeatureIcon 
                        IconComponent={CiDeliveryTruck} 
                        title="Seamless Logistics" 
                        description="We manage material sourcing, shipping, and installation for a worry-free process."
                    />
                </div>

                <a href="/login" className="btn-primary">Start Your Custom Project</a>
            </div>
        </section>
    );
};

export default WhyUs;